import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getReferenceDataDomains } from "../../../../axios/api/services";
import {
  fulfilledThunkState,
  initialThunkState,
  pendingThunkState,
  rejectedThunkState,
  commonThunkCondition,
} from "@duosoftbg/nacid-components";

const sliceName = "appData/referenceDataDomains";
const referenceDataDomainsSlice = createSlice({
  name: sliceName,
  initialState: initialThunkState([]),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(referenceDataDomainsThunk.pending, (state, action) => {
      return pendingThunkState(state);
    });
    builder.addCase(referenceDataDomainsThunk.fulfilled, (state, action) => {
      const { data } = action.payload;
      return fulfilledThunkState(data);
    });
    builder.addCase(referenceDataDomainsThunk.rejected, (state, action) => {
      return rejectedThunkState([]);
    });
  },
});

export const referenceDataDomainsThunk = createAsyncThunk(
  `${sliceName}/referenceDataDomainsThunk`,
  async () => {
    const response = await getReferenceDataDomains()();
    return { data: response };
  },
  {
    condition: (_, { getState, extra }) => {
      return commonThunkCondition(getState()["AppData"]?.referenceDataDomains);
    },
  },
);

export default referenceDataDomainsSlice.reducer;
